const INIT_ITEMS = [
  {
    title: 'Warming up',
    description: 'Getting things ready.'
  },
  {
    title: 'Starting up',
    description: 'Spinning up my workspace.'
  },
  {
    title: 'Loading tools',
    description: 'Prepping search and analysis.'
  },
  {
    title: 'Connecting',
    description: 'Linking to my sources.'
  },
  {
    title: 'Calibrating',
    description: 'Lining up the basics.'
  },
  {
    title: 'System check',
    description: 'Quick preflight before I begin.'
  },
  {
    title: 'Getting organized',
    description: 'Setting the stage for a clean run.'
  },
  {
    title: 'Almost there',
    description: 'Setup is nearly done.'
  },
  {
    title: 'Standing by',
    description: 'I\'ll begin as setup completes.'
  },
  {
    title: 'Ready soon',
    description: 'Final touches before I start.'
  },
  {
    title: 'Booting up',
    description: 'Bringing services online.'
  },
  {
    title: 'Initializing',
    description: 'Readying up components.'
  },
  {
    title: 'Preloading tools',
    description: 'Loading essentials into memory.'
  },
  {
    title: 'Checking access',
    description: 'Ensuring I can reach my sources.'
  },
  {
    title: 'Securing session',
    description: 'Setting a safe workspace.'
  },
  {
    title: 'Syncing sources',
    description: 'Making sure connections are current.'
  },
  {
    title: 'Health check',
    description: 'Systems look stable.'
  },
  {
    title: 'Network check',
    description: 'Links are steady and responsive.'
  },
  {
    title: 'Caching basics',
    description: 'Storing essentials for speed.'
  },
  {
    title: 'Priming memory',
    description: 'Keeping key pieces handy.'
  },
  {
    title: 'Housekeeping',
    description: 'Tidying up the workspace.'
  },
  {
    title: 'Tuning settings',
    description: 'Dialing in defaults.'
  },
  {
    title: 'Waking tools',
    description: 'Specialists are on standby.'
  },
  {
    title: 'Staging steps',
    description: 'Ordering the first moves.'
  },
  {
    title: 'Plan queued',
    description: 'First actions are lined up.'
  },
  {
    title: 'Focus locked',
    description: 'I know where to begin.'
  },
  {
    title: 'Fresh start',
    description: 'Clean environment ready.'
  },
  {
    title: 'Stable build',
    description: 'Everything\'s pinned and ready.'
  },
  {
    title: 'Session open',
    description: 'Workspace is active.'
  },
  {
    title: 'Quick test ',
    description: 'Everything responds as expected.'
  },
  {
    title: 'Performance primed ',
    description: 'Smooth run ahead.'
  }
]

 
function simpleHash(str) {
  let hash = 5381
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i)
    // Bitwise left shift is a fast way to multiply by 32
    hash = ((hash << 5) + hash) + char /* hash * 33 + char */
  }
  // Ensure the result is non-negative
  return Math.abs(hash)
}

export default function uuidToItems(uuid) {
  if (!uuid || typeof uuid !== 'string') {
    console.error('Invalid input: A non-empty string UUID is required.')
    alert('here')
    return [INIT_ITEMS[0], INIT_ITEMS[1]] // Return a default pair for invalid input
  }
  const rangeSize = INIT_ITEMS.length // We want numbers from 0 to 20, which is 21 possible values.

  // Generate the first number by hashing the original UUID.
  const hash1 = simpleHash(uuid)
  let num1 = hash1 % rangeSize

  // Generate the second number by hashing a slightly modified version of the UUID.
  // Appending a "salt" ensures we get a different hash.
  const hash2 = simpleHash(uuid + '-salt')
  let num2 = hash2 % rangeSize

  // Ensure the two numbers are not the same.
  // If they are, we deterministically pick the "next" number in the range.
  if (num1 === num2) {
    num2 = (num2 + 1) % rangeSize
  }

  return [INIT_ITEMS[num1], INIT_ITEMS[num2]]
}